import Vue from 'vue';
import axios from 'axios';
//import https from 'https'
import Constants from '@/plugins/constants';

import { recoveryClient } from '@/plugins/apiClient';
//axios.defaults.options.rejectUnauthorized = false;

const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
});
const apiClient2 = axios.create({
  withCredentials: true,
  baseURL: Constants.MAINURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
const apiClientCapthch = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);
apiClient2.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);
apiClientCapthch.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  successFlag: false,
  errorStatus: null,
  csrf: null,
  chaptchaData: null,
};
const getters = {
  getApiLoad_43: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_CSRF(state, data) {
    state.csrf = data;
  },
  SET_Captcha(state, data) {
    state.chaptchaData = data;
  },
};
const actions = {
  errorLogin({ commit }, temperror) {
    var error = temperror;
    if (error && error?.response?.status !== 400) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
          } else {
            commit('SET_errorStatus', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else if (error && error?.response?.status === 400) {
      return;
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  loginUser({ commit, dispatch }, user) {
    return apiClient2
      .post('/Users/Login', user)
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorLogin', error);
      });
  },
  loginUserWithCaptcha({ commit, dispatch }, user) {
    return apiClient2
      .post('/Users/LoginWithCaptcha', user)
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorLogin', error);
      });
  },
  csrf({ commit }) {
    return apiClient
      .post('/Users/CSRFToken', {}, { withCredentials: true })
      .then((response) => {
        commit('SET_CSRF', response.data);
        commit('SET_Status', true);
      })
      .catch(() => {
        // dispatch("errorLogin", error);
      });
  },

  csrf_New({ commit }) {
    return recoveryClient
      .post('/Users/CSRFToken', {}, {
        withCredentials: true,
      })
      .then((response) => {
        commit('SET_CSRF', response.data);
        commit('SET_Status', true);
        return response;
      })
      .catch((error) => {
        commit('SET_Status', false);
        throw error;
      });
  },


  chaptcha({ commit, dispatch }) {
    return apiClientCapthch
      .get('/Users/Captcha')
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_Captcha', response.data);
      })
      .catch((error) => {
        dispatch('errorLogin', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
